import React, { useMemo, useEffect } from 'react';
import styled from '@/shared/styled';
// import { Route } from '@souche-f2e/muji-router';
import { connect } from '@souche-f2e/muji';
import { getUrlByPath, addTimestampToUrlSearch } from '@/shared/utils';
import { Empty } from 'antd';
import { dispatch } from '@@/store';
import { addMessageListener } from '@souche-f2e/muji-plugin-history-launcher/lib/browser';
const Root = styled.div `
  width: 100%;
  height: calc(100vh - 64px);
  overflow: hidden;
  > iframe {
    width: 100%;
    height: 100%;
  }
`;
const mapStateToProps = ({ menu }) => {
    return {
        rawData: menu.rawData,
    };
};
// const data = {
//   code: '200',
//   data: [
//     {
//       buried: 'CYBERTRON_PLATFORM_WORKBENCH',
//       children: [],
//       id: 1,
//       name: '首页',
//       notifyExpireDate: '2020-06-18 14:12:39',
//       notifyMessage: '',
//       notifyRedPoint: false,
//       notifyStartDate: '2020-06-16 00:00:00',
//       parentId: 0,
//       path: 'dashboard',
//       redpointSetting: false,
//       resourceCode: '',
//       type: 0,
//       url: 'https://devops.souche-inc.com/#/dashboard',
//     },
//     {
//       buried: '',
//       children: [
//         {
//           buried: '',
//           children: [],
//           id: 236,
//           name: '研发协作平台',
//           notifyRedPoint: false,
//           parentId: 235,
//           path: 'cooperation',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://f2e-assets.souche-inc.com/projects/data-fe/cybertron-cooperation-web/index.html#/dashboard',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 239,
//           name: '应用管理',
//           notifyExpireDate: '2021-05-01 23:59:59',
//           notifyMessage: '',
//           notifyRedPoint: false,
//           notifyStartDate: '2021-01-29 00:00:00',
//           parentId: 235,
//           path: 'application',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'f2e-assets.souche-inc.com/projects/data-fe/cybertron-pipeline-web/#/home',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 238,
//           name: '环境管理',
//           notifyRedPoint: false,
//           parentId: 235,
//           path: 'envs',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://f2e-assets.souche-inc.com/projects/data-fe/env-manager/#/',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 240,
//           name: '持续集成',
//           notifyRedPoint: false,
//           parentId: 235,
//           path: 'soucheci',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://f2e-assets.souche-inc.com/projects/data-fe/cybertron-ci-web/#/dashboard',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 243,
//           name: '工作台',
//           notifyExpireDate: '2021-04-15 23:59:59',
//           notifyMessage: '原首页已经迁移到工程效率-工作台',
//           notifyRedPoint: false,
//           notifyStartDate: '2021-03-23 00:00:00',
//           parentId: 235,
//           path: 'workbench',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'f2e-assets.souche-inc.com/projects/data-fe/cybertron-workflow-web/',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 242,
//           name: '二方库发布',
//           notifyExpireDate: '2021-05-01 23:59:59',
//           notifyMessage: '应用管理里面勾选了SDK属性的应用才可以在此发布',
//           notifyRedPoint: false,
//           notifyStartDate: '2021-01-29 00:00:00',
//           parentId: 235,
//           path: 'erfang-publish',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://assets.souche-inc.com/projects/data-fe/cybertron-cooperation-web/#/publishLibrary',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 244,
//           name: 'Maven依赖',
//           notifyExpireDate: '2021-04-30 23:59:59',
//           notifyMessage: '',
//           notifyRedPoint: false,
//           notifyStartDate: '2021-04-06 00:00:00',
//           parentId: 235,
//           path: 'packageDependency',
//           redpointSetting: true,
//           resourceCode: '',
//           type: 1,
//           url: 'https://assets.souche-inc.com/projects/data-fe/package-supervise/#/packageDependency/rely',
//         },
//       ],
//       id: 235,
//       name: '工程效率',
//       notifyExpireDate: '2020-08-30 23:59:59',
//       notifyMessage: '',
//       notifyRedPoint: false,
//       notifyStartDate: '2020-08-11 00:00:00',
//       parentId: 0,
//       path: 'efficiency',
//       redpointSetting: true,
//       resourceCode: '',
//       type: 0,
//       url: '',
//     },
//     {
//       buried: '',
//       children: [
//         {
//           buried: '',
//           children: [],
//           id: 97,
//           name: 'ocean数据库平台',
//           notifyRedPoint: false,
//           parentId: 93,
//           path: 'https://ocean.souche-inc.com/',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://ocean.souche-inc.com/',
//         },
//         {
//           buried: '',
//           children: [
//             {
//               buried: '',
//               children: [],
//               id: 262,
//               name: '搜车预发集群',
//               notifyRedPoint: false,
//               parentId: 258,
//               path: 'https://terminals.prepub.souche-inc.com/#/login',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//             {
//               buried: '',
//               children: [],
//               id: 263,
//               name: '搜车线上集群',
//               notifyRedPoint: false,
//               parentId: 258,
//               path: 'https://terminals2.souche-inc.com/#/login',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//             {
//               buried: '',
//               children: [],
//               id: 264,
//               name: '车易拍线上集群',
//               notifyRedPoint: false,
//               parentId: 258,
//               path: 'https://terminals.souche-inc.com/containers',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//           ],
//           id: 258,
//           name: '容器登陆平台',
//           notifyRedPoint: false,
//           parentId: 93,
//           path: 'terminal',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: '',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 108,
//           name: '运维平台(ark)',
//           notifyMessage: 'ark',
//           notifyRedPoint: false,
//           parentId: 93,
//           path: 'ark',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://ark.souche-inc.com/home',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 257,
//           name: '稳定性运营平台',
//           notifyExpireDate: '2022-09-09 23:59:59',
//           notifyMessage: '',
//           notifyRedPoint: false,
//           notifyStartDate: '2022-09-08 00:00:00',
//           parentId: 93,
//           path: 'https://greatwall.souche-inc.com/#/home/businessOverview',
//           redpointSetting: true,
//           resourceCode: '',
//           type: 1,
//           url: 'https://greatwall.souche-inc.com/#/home/businessOverview',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 248,
//           name: '虹猫',
//           notifyRedPoint: false,
//           parentId: 93,
//           path: 'https://assets.souche-inc.com/projects/devop/hongmao-fore-dev/#/dashboard',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://assets.souche-inc.com/projects/devop/hongmao-fore-dev/#/dashboard',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 111,
//           name: '阿里云控制台',
//           notifyRedPoint: false,
//           parentId: 93,
//           path: 'https://auth.souche-inc.com/auth/realms/Teleport/protocol/saml/clients/aliyun',
//           redpointSetting: false,
//           type: 1,
//           url: 'https://auth.souche-inc.com/auth/realms/Teleport/protocol/saml/clients/aliyun',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 227,
//           name: '监控中心',
//           notifyExpireDate: '2020-06-30 23:59:59',
//           notifyMessage:
//             '去掉一级菜单【监控&报警】，增加二级菜单【监控中心】【报警中心】；\n菜单内容没有变化；',
//           notifyRedPoint: false,
//           notifyStartDate: '2020-06-16 00:00:00',
//           parentId: 93,
//           path: 'monitor',
//           redpointSetting: true,
//           resourceCode: '',
//           type: 1,
//           url: 'graf.souche-inc.com',
//         },
//         {
//           buried: '',
//           children: [
//             {
//               buried: '',
//               children: [],
//               id: 146,
//               name: '线上&预发MQ',
//               notifyMessage: '已下线',
//               notifyRedPoint: false,
//               parentId: 145,
//               path: 'proMQ',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: 'https://rocketmq-console.souche-inc.com/#/topic',
//             },
//             {
//               buried: '',
//               children: [],
//               id: 148,
//               name: '测试环境MQ',
//               notifyRedPoint: false,
//               parentId: 145,
//               path: 'qaMQ',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: 'https://stable-mq-console.dasouche-inc.net/#/',
//             },
//           ],
//           id: 145,
//           name: 'RocketMQ',
//           notifyRedPoint: false,
//           parentId: 93,
//           path: 'MQ',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: '',
//         },
//         {
//           buried: '',
//           children: [
//             {
//               buried: '',
//               children: [],
//               id: 260,
//               name: '老部署系统',
//               notifyRedPoint: false,
//               parentId: 259,
//               path: 'opsDeploy',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: 'https://deployd-v2.souche-inc.com',
//             },
//             {
//               buried: '',
//               children: [],
//               id: 261,
//               name: '容器部署系统',
//               notifyRedPoint: false,
//               parentId: 259,
//               path: 'deployd-k8s',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: 'https://assets.souche-inc.com/projects/basic-process/deployd-k8s-fe/#/orders/list',
//             },
//           ],
//           id: 259,
//           name: '部署系统',
//           notifyRedPoint: false,
//           parentId: 93,
//           path: 'deploy',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: '',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 120,
//           name: '域名解析管理',
//           notifyMessage: '',
//           notifyRedPoint: false,
//           parentId: 93,
//           path: 'dns',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://assets.souche-inc.com/projects/devop/dns-manager-fe/#/domains/list',
//         },
//         {
//           buried: 'CYBERTRON_PLATFORM_CYBERTRON',
//           children: [],
//           id: 94,
//           name: '发布单',
//           notifyExpireDate: '2020-02-15 23:59:59',
//           notifyMessage:
//             '前端应用支持测试自助发布，点击同意发布后可通过应用后面的 “一键部署”发布应用~ 文档：https://souche.yuque.com/hwetr3/un0aga/iwyhsi',
//           notifyRedPoint: false,
//           notifyStartDate: '2020-02-06 00:00:00',
//           parentId: 93,
//           path: 'deploy',
//           redpointSetting: true,
//           resourceCode: '',
//           type: 1,
//           url: 'https://cybertron.souche-inc.com/#/deploy',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 107,
//           name: 'Rundeck',
//           notifyRedPoint: false,
//           parentId: 93,
//           path: 'rundeck',
//           redpointSetting: false,
//           type: 1,
//           url: 'https://rundeck-wrapper.souche-inc.com/#/count',
//         },
//       ],
//       id: 93,
//       name: '运维',
//       notifyExpireDate: '2020-07-04 23:59:59',
//       notifyMessage: '',
//       notifyRedPoint: false,
//       notifyStartDate: '2020-06-16 00:00:00',
//       parentId: 0,
//       path: 'ops',
//       redpointSetting: true,
//       resourceCode: '',
//       type: 0,
//       url: '',
//     },
//     {
//       children: [
//         {
//           buried: 'CYBERTRON_PLATFORM_OPTIMUS_LOG',
//           children: [],
//           id: 5,
//           name: 'Optimus Log',
//           notifyExpireDate: '2019-11-21 23:59:59',
//           notifyMessage: '',
//           notifyRedPoint: false,
//           notifyStartDate: '2019-11-21 00:00:00',
//           parentId: 2,
//           path: 'log',
//           redpointSetting: false,
//           type: 2,
//           url: 'logplatform.souche-inc.com',
//         },
//         {
//           children: [
//             {
//               buried: 'CYBERTRON_PLATFORM_OPTIMUS_APOLLO',
//               children: [],
//               id: 18,
//               name: '配置管理',
//               notifyExpireDate: '2019-11-21 23:59:59',
//               notifyMessage: '',
//               notifyRedPoint: false,
//               notifyStartDate: '2019-11-21 00:00:00',
//               parentId: 7,
//               path: 'apollo',
//               redpointSetting: false,
//               type: 2,
//               url: 'apollo.souche-inc.com',
//             },
//             {
//               buried: 'CYBERTRON_PLATFORM_OPTIMUS_APOLLO_USER',
//               children: [],
//               id: 19,
//               name: '用户管理',
//               notifyRedPoint: false,
//               parentId: 7,
//               path: 'user',
//               redpointSetting: false,
//               type: 2,
//               url: 'apollo.souche-inc.com/user-manage.html',
//             },
//             {
//               buried: 'CYBERTRON_PLATFORM_OPTIMUS_APOLLO_API',
//               children: [],
//               id: 20,
//               name: 'OPENAPI',
//               notifyRedPoint: false,
//               parentId: 7,
//               path: 'api',
//               redpointSetting: false,
//               type: 2,
//               url: 'apollo.souche-inc.com/open/manage.html',
//             },
//             {
//               buried: 'CYBERTRON_PLATFORM_OPTIMUS_APOLLO_SYSTEM',
//               children: [],
//               id: 21,
//               name: '系统设置',
//               notifyRedPoint: false,
//               parentId: 7,
//               path: 'server',
//               redpointSetting: false,
//               type: 2,
//               url: 'apollo.souche-inc.com/server_config.html',
//             },
//           ],
//           id: 7,
//           name: 'Optimus Config',
//           notifyRedPoint: false,
//           parentId: 2,
//           path: 'config',
//           redpointSetting: false,
//           type: 1,
//         },
//         {
//           buried: 'CYBERTRON_PLATFORM_OPTIMUS_ASYNCTASK',
//           children: [],
//           id: 8,
//           name: 'Optimus AsyncTask',
//           notifyRedPoint: false,
//           parentId: 2,
//           path: 'async-task',
//           redpointSetting: false,
//           type: 2,
//           url: 'op-task-web.souche-inc.com/#/main',
//         },
//         {
//           children: [
//             {
//               buried: 'CYBERTRON_PLATFORM_OPTIMUS_JOB_TASK',
//               children: [],
//               id: 22,
//               name: '任务管理',
//               notifyRedPoint: false,
//               parentId: 9,
//               path: 'opjob',
//               redpointSetting: false,
//               type: 2,
//               url: 'opjob.souche-inc.com/#/taskManagement',
//             },
//             {
//               buried: 'CYBERTRON_PLATFORM_OPTIMUS_JOB_WORKER',
//               children: [],
//               id: 23,
//               name: 'Worker管理',
//               notifyRedPoint: false,
//               parentId: 9,
//               path: 'worker',
//               redpointSetting: false,
//               type: 2,
//               url: 'opjob.souche-inc.com/#/actuatorManagement',
//             },
//             {
//               buried: 'CYBERTRON_PLATFORM_OPTIMUS_JOB_REPORT',
//               children: [],
//               id: 24,
//               name: '运行报表',
//               notifyRedPoint: false,
//               parentId: 9,
//               path: 'report',
//               redpointSetting: false,
//               type: 2,
//               url: 'opjob.souche-inc.com/#/index',
//             },
//           ],
//           id: 9,
//           name: 'Optimus Job',
//           notifyRedPoint: false,
//           parentId: 2,
//           path: 'job',
//           redpointSetting: false,
//           type: 1,
//         },
//         {
//           buried: 'CYBERTRON_PLATFORM_OPTIMUS_START',
//           children: [],
//           id: 81,
//           name: 'Optimus Start',
//           notifyMessage: '',
//           notifyRedPoint: false,
//           parentId: 2,
//           path: 'optimus-initializr',
//           redpointSetting: false,
//           type: 2,
//           url: 'optimus-initializr.souche-inc.com/index.html',
//         },
//         {
//           children: [
//             {
//               buried: '',
//               children: [],
//               id: 134,
//               name: '新版大盘',
//               notifyRedPoint: false,
//               parentId: 10,
//               path: 'newTrace',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: 'https://optimus-trace.souche-inc.com/#/newarch?urlQueryConditon=%257B%2522szone%2522%253A%2522souche%2522%252C%2522app%2522%253A%2522automobile-station%2522%252C%2522timeRange%2522%253A%257B%2522title%2522%253A%25225%25E5%2588%2586%25E9%2592%259F%25E5%2589%258D%2522%252C%2522value%2522%253A300000%252C%2522startDate%2522%253A1576480626526%252C%2522endDate%2522%253A1576480926526%257D%257D',
//             },
//             {
//               buried: 'CYBERTRON_PLATFORM_OPTIMUS_TRANCE_SEARCH',
//               children: [],
//               id: 25,
//               name: '链路查询',
//               notifyRedPoint: false,
//               parentId: 10,
//               path: 'trace',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: 'trace.souche-inc.com/index.html',
//             },
//           ],
//           id: 10,
//           name: 'Optimus Trace',
//           notifyRedPoint: false,
//           parentId: 2,
//           path: 'trace',
//           redpointSetting: false,
//           type: 1,
//         },
//         {
//           buried: '',
//           children: [],
//           id: 150,
//           name: 'Optimus Mq Console',
//           notifyExpireDate: '2020-03-06 23:59:59',
//           notifyMessage: '',
//           notifyRedPoint: false,
//           notifyStartDate: '2020-03-05 00:00:00',
//           parentId: 2,
//           path: 'mqConsole',
//           redpointSetting: true,
//           resourceCode: '',
//           type: 1,
//           url: '1https://rocketmq-console.souche-inc.com/#/topic',
//         },
//       ],
//       id: 2,
//       name: '中间件',
//       notifyExpireDate: '2020-03-06 23:59:59',
//       notifyMessage: '',
//       notifyRedPoint: false,
//       notifyStartDate: '2020-03-05 00:00:00',
//       parentId: 0,
//       path: 'optimus',
//       redpointSetting: false,
//       type: 0,
//     },
//     {
//       buried: 'DEVOPS_MENU_WIRELESS',
//       children: [
//         {
//           buried: '',
//           children: [
//             {
//               buried: '',
//               children: [],
//               id: 190,
//               name: '打包部署',
//               notifyRedPoint: false,
//               parentId: 188,
//               path: 'https://devops.souche-inc.com/#/efficiency/application',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//           ],
//           id: 188,
//           name: '项目相关',
//           notifyExpireDate: '2021-01-31 23:59:59',
//           notifyMessage:
//             '集团无线应用构建平台\n- 支持前端（H5 / RN / 小程序）的 App 和二方库的 创建 & 打包 & 部署 / 发布 \n- 支持客户端（iOS / Android）App 和 SDK的 创建 & 打包 & 部署 / 发布',
//           notifyRedPoint: false,
//           notifyStartDate: '2020-11-01 00:00:00',
//           parentId: 180,
//           path: 'wireless_app',
//           redpointSetting: true,
//           resourceCode: '',
//           type: 1,
//           url: '',
//         },
//         {
//           buried: '',
//           children: [
//             {
//               buried: '',
//               children: [],
//               id: 192,
//               name: '开发规约',
//               notifyRedPoint: false,
//               parentId: 191,
//               path: 'https://souche.yuque.com/tttgx4/xgmuxx/gd5g28',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//             {
//               buried: '',
//               children: [
//                 {
//                   buried: '',
//                   children: [],
//                   id: 195,
//                   name: '集团移动端 H5 组件库',
//                   notifyExpireDate: '2021-01-31 23:59:59',
//                   notifyMessage: '集团前端组件化已正式上线，请及时接入更新！',
//                   notifyRedPoint: false,
//                   notifyStartDate: '2020-11-16 00:00:00',
//                   parentId: 193,
//                   path: 'https://som-ui.dasouche-inc.net/#/',
//                   redpointSetting: true,
//                   resourceCode: '',
//                   type: 3,
//                   url: '',
//                 },
//                 {
//                   buried: '',
//                   children: [],
//                   id: 196,
//                   name: '集团 PC 端 Web 组件库',
//                   notifyExpireDate: '2021-01-31 23:59:59',
//                   notifyMessage: '集团前端组件化已正式上线，请及时接入更新！',
//                   notifyRedPoint: false,
//                   notifyStartDate: '2020-11-16 00:00:00',
//                   parentId: 193,
//                   path: 'https://antd-extends.dasouche-inc.net/',
//                   redpointSetting: true,
//                   resourceCode: '',
//                   type: 3,
//                   url: '',
//                 },
//                 {
//                   buried: '',
//                   children: [],
//                   id: 194,
//                   name: '集团移动端 RN 组件库（RN 0.61.2）',
//                   notifyExpireDate: '2021-01-31 23:59:59',
//                   notifyMessage: '集团前端组件化已正式上线，请及时接入更新！',
//                   notifyRedPoint: false,
//                   notifyStartDate: '2020-11-16 00:00:00',
//                   parentId: 193,
//                   path: 'https://srn-ui.dasouche-inc.net/docs/components/init/',
//                   redpointSetting: true,
//                   resourceCode: '',
//                   type: 3,
//                   url: '',
//                 },
//               ],
//               id: 193,
//               name: 'UI 组件库',
//               notifyExpireDate: '2021-01-31 23:59:59',
//               notifyMessage: '集团前端组件化已正式上线，请及时接入更新！',
//               notifyRedPoint: false,
//               notifyStartDate: '2020-11-16 00:00:00',
//               parentId: 191,
//               path: 'ui_resource',
//               redpointSetting: true,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//             {
//               buried: '',
//               children: [
//                 {
//                   buried: '',
//                   children: [],
//                   id: 198,
//                   name: '集团 RN 框架 Thanos（RN 0.61.2）',
//                   notifyRedPoint: false,
//                   parentId: 197,
//                   path: 'https://srn.dasouche-inc.net/',
//                   redpointSetting: false,
//                   resourceCode: '',
//                   type: 3,
//                   url: '',
//                 },
//                 {
//                   buried: '',
//                   children: [],
//                   id: 199,
//                   name: '集团 PC 端框架 Muji',
//                   notifyRedPoint: false,
//                   parentId: 197,
//                   path: 'https://muji.dasouche-inc.net/',
//                   redpointSetting: false,
//                   resourceCode: '',
//                   type: 3,
//                   url: '',
//                 },
//               ],
//               id: 197,
//               name: '开发框架',
//               notifyRedPoint: false,
//               parentId: 191,
//               path: 'dev_framework',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//           ],
//           id: 191,
//           name: '组件 & 框架',
//           notifyExpireDate: '2021-01-31 23:59:59',
//           notifyMessage: '集团前端组件化已正式上线，请及时接入更新！',
//           notifyRedPoint: false,
//           notifyStartDate: '2020-11-16 00:00:00',
//           parentId: 180,
//           path: 'wireless_assets',
//           redpointSetting: true,
//           resourceCode: '',
//           type: 1,
//           url: '',
//         },
//         {
//           buried: '',
//           children: [
//             {
//               buried: '',
//               children: [],
//               id: 185,
//               name: 'Reiko 托管',
//               notifyRedPoint: false,
//               parentId: 184,
//               path: 'https://reiko.souche-inc.com/',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//             {
//               buried: '',
//               children: [],
//               id: 187,
//               name: 'Sentry 日志平台',
//               notifyRedPoint: false,
//               parentId: 184,
//               path: 'http://sentry.souche-inc.com',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//             {
//               buried: '',
//               children: [],
//               id: 247,
//               name: 'IOS 证书管理',
//               notifyRedPoint: false,
//               parentId: 184,
//               path: 'certificate',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: 'f2e.prepub.souche-inc.com/projects/wireless-devops/web-app-wireless-certificate-management-fe/#/',
//             },
//           ],
//           id: 184,
//           name: '开发平台',
//           notifyRedPoint: false,
//           parentId: 180,
//           path: 'dev_platform',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: '',
//         },
//         {
//           buried: '',
//           children: [
//             {
//               buried: '',
//               children: [],
//               id: 201,
//               name: '短信平台',
//               notifyRedPoint: false,
//               parentId: 183,
//               path: 'http://sms-center.souche-inc.com',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//             {
//               buried: '',
//               children: [],
//               id: 203,
//               name: '推送中心',
//               notifyRedPoint: false,
//               parentId: 183,
//               path: 'http://msgcenter.souche-inc.com/#/status',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//             {
//               buried: '',
//               children: [],
//               id: 204,
//               name: '开放平台',
//               notifyRedPoint: false,
//               parentId: 183,
//               path: 'http://openconsole.souche-inc.com/',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//             {
//               buried: '',
//               children: [],
//               id: 205,
//               name: '服务市场',
//               notifyRedPoint: false,
//               parentId: 183,
//               path: 'http://fuwu.souche-inc.com/',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: '',
//             },
//           ],
//           id: 183,
//           name: '运营平台',
//           notifyRedPoint: false,
//           parentId: 180,
//           path: 'http://dio.souche-inc.com/',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: '',
//         },
//       ],
//       id: 180,
//       name: '无线',
//       notifyExpireDate: '2021-01-31 23:59:59',
//       notifyMessage: '集团前端组件化已正式上线，请及时接入更新！',
//       notifyRedPoint: false,
//       notifyStartDate: '2020-11-16 00:00:00',
//       parentId: 0,
//       path: 'web',
//       redpointSetting: false,
//       resourceCode: '',
//       type: 0,
//       url: '',
//     },
//     {
//       buried: '',
//       children: [
//         {
//           buried: '',
//           children: [],
//           id: 162,
//           name: '数据工厂',
//           notifyRedPoint: false,
//           parentId: 161,
//           path: 'http://data-factory.dasouche-inc.net/#/datas/contexts',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'http://data-factory.dasouche-inc.net/#/datas/contexts',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 164,
//           name: '代码测试覆盖率',
//           notifyRedPoint: false,
//           parentId: 161,
//           path: 'https://quality-center.dasouche-inc.net/#/workbench/codeCoverage',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://quality-center.dasouche-inc.net/#/workbench/codeCoverage',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 171,
//           name: '功能测试报告',
//           notifyRedPoint: false,
//           parentId: 161,
//           path: 'http://quality-center.dasouche-inc.net/#/workbench/report/list',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'http://quality-center.dasouche-inc.net/#/workbench/report/list',
//         },
//         {
//           buried: '',
//           children: [
//             {
//               buried: '',
//               children: [],
//               id: 178,
//               name: '测试环境',
//               notifyRedPoint: false,
//               parentId: 165,
//               path: 'https://quality-center.dasouche-inc.net/#/tools/TraceDataQuery',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: 'https://quality-center.dasouche-inc.net/#/tools/TraceDataQuery',
//             },
//             {
//               buried: '',
//               children: [],
//               id: 179,
//               name: '预发&线上环境',
//               notifyRedPoint: false,
//               parentId: 165,
//               path: 'https://quality-center.prepub.souche-inc.com/#/tools/TraceDataQuery',
//               redpointSetting: false,
//               resourceCode: '',
//               type: 2,
//               url: 'https://quality-center.prepub.souche-inc.com/#/tools/TraceDataQuery',
//             },
//           ],
//           id: 165,
//           name: '接口自动化对比',
//           notifyRedPoint: false,
//           parentId: 161,
//           path: 'tools',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: '',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 234,
//           name: '测试接入CICD',
//           notifyRedPoint: false,
//           parentId: 161,
//           path: 'http://quality-center.dasouche-inc.net/#/control_center/',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'http://quality-center.dasouche-inc.net/#/control_center/',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 237,
//           name: '测试用例管理',
//           notifyRedPoint: false,
//           parentId: 161,
//           path: 'http://quality-center.dasouche-inc.net/#/tools/testcaseManage',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'http://quality-center.dasouche-inc.net/#/tools/testcaseManage',
//         },
//       ],
//       id: 161,
//       name: '质量',
//       notifyExpireDate: '2022-04-13 23:59:59',
//       notifyMessage: '',
//       notifyRedPoint: false,
//       notifyStartDate: '2022-03-17 00:00:00',
//       parentId: 0,
//       path: 'quality-center',
//       redpointSetting: true,
//       resourceCode: '',
//       type: 0,
//       url: '',
//     },
//     {
//       buried: 'CYBERTRON_HELP',
//       children: [],
//       id: 138,
//       name: '帮助',
//       notifyRedPoint: false,
//       parentId: 0,
//       path: 'help',
//       redpointSetting: false,
//       resourceCode: '',
//       type: 0,
//       url: 'devops.souche-inc.com/#/helpDoc',
//     },
//     {
//       buried: '',
//       children: [
//         {
//           buried: '',
//           children: [],
//           id: 125,
//           name: '菜单管理',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'deploymenu',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://devops.souche-inc.com/#/deployMenu',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 126,
//           name: '流水线配置',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'pieline',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://devops.souche-inc.com/#/ops/pipeline',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 127,
//           name: '发布单审批人配置',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'auditor',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://cybertron.souche-inc.com/#/auditor',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 128,
//           name: '工作流配置',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'flow-setting',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://f2e-assets.souche.com/projects/cybertron-workflow-web/#/process',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 129,
//           name: '封版日设置',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'locktip',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://cybertron.souche-inc.com/#/locktip',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 132,
//           name: '业务线配置',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'zone',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://cybertron-project.souche-inc.com/#/setting/zone',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 245,
//           name: '协作平台封板日控制',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'https://f2e-assets.souche-inc.com/projects/data-fe/cybertron-cooperation-web/index.html?tofd=1626688007609#/dateWhiteList',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://f2e-assets.souche-inc.com/projects/data-fe/cybertron-cooperation-web/index.html?tofd=1626688007609#/dateWhiteList',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 249,
//           name: '首页公告',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'https://devops.souche-inc.com/#/deployCarousel',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://devops.souche-inc.com/#/deployCarousel',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 250,
//           name: 'git组负责人设置',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'groupOwner',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://assets.souche-inc.com/projects/data-fe/cybertron-pipeline-web/#/groupOwner',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 255,
//           name: '三方包黑名单',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'blacklist',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: 'https://f2e-assets.souche-inc.com/projects/data-fe/package-supervise/#/otherBlackList',
//         },
//         {
//           buried: '',
//           children: [],
//           id: 256,
//           name: '紧急发布审批人设置',
//           notifyRedPoint: false,
//           parentId: 124,
//           path: 'http://assets.souche-inc.com/projects/data-fe/cybertron-cooperation-web/#/emergencyApprover',
//           redpointSetting: false,
//           resourceCode: '',
//           type: 1,
//           url: '',
//         },
//       ],
//       id: 124,
//       name: '系统管理',
//       notifyRedPoint: false,
//       parentId: 0,
//       path: 'system',
//       redpointSetting: false,
//       resourceCode: 'DEVOPS-SYSTEM',
//       type: 0,
//       url: '',
//     },
//   ],
//   msg: 'success',
//   success: true,
//   traceId: 'mSmwq5',
// };
const PageView = ({ className, style, currentRoute, rawData, }) => {
    const iframeURL = useMemo(() => {
        const { protocol } = window.location;
        const url = getUrlByPath(currentRoute.path, rawData);
        const { query } = currentRoute;
        if (query && query.url) {
            if (query.useBase64 === 'true') {
                return addTimestampToUrlSearch(atob(query.url));
            }
            return addTimestampToUrlSearch(query.url);
        }
        if (/^https?:\/\//.test(url)) {
            return addTimestampToUrlSearch(url);
        }
        const fullUrl = url && `${protocol}//${url}`;
        if (fullUrl) {
            return addTimestampToUrlSearch(fullUrl);
        }
        return fullUrl;
    }, [currentRoute.path]);
    useEffect(() => {
        addMessageListener(url => {
            dispatch.router.replace({
                query: {
                    url,
                },
            });
        });
    }, []);
    return (<Root className={className} style={style}>
      {iframeURL ? (<iframe src={iframeURL} frameBorder="0"/>) : (<Empty description="页面不存在" style={{ marginTop: 120 }}/>)}
    </Root>);
};
export default connect(mapStateToProps)(PageView);
